import { Reveal, Overline } from "@/components/Reveal";
import { OFFICE_PHOTOS, SITE } from "@/lib/site";

// Real office/team photos — E-E-A-T trust. Reused on About + Partners.
export function OfficeGallery({ compact = false }) {
  return (
    <section className="py-20 md:py-28 border-t border-[var(--tx-border)]" data-testid="office-gallery">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal><Overline>Inside our offices</Overline></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display font-light tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-3xl">
            Real teams, real ground presence — {SITE.addressLine.replace("Head Office: ", "").replace("Branch: ", "& ")}
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-5 max-w-2xl text-[var(--tx-text-2)] leading-relaxed">
            We&apos;re a working DMC with our own operations floors in the North East — a unit of {SITE.parentCompany}.
            When you partner with TripTrix, a real, on-ground team handles your files.
          </p>
        </Reveal>
        <div className={`mt-12 grid gap-4 sm:grid-cols-2 ${compact ? "lg:grid-cols-3" : "lg:grid-cols-3"}`}>
          {(compact ? OFFICE_PHOTOS.slice(0, 3) : OFFICE_PHOTOS).map((p, i) => (
            <Reveal key={p.src} delay={(i % 3) * 0.08}>
              <div className={`relative overflow-hidden ${i === 0 && !compact ? "sm:col-span-2 lg:col-span-1" : ""}`}>
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="h-72 w-full object-cover transition-transform duration-700 hover:scale-105"
                  data-testid={`office-photo-${i}`}
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                  <p className="text-xs text-white/80">{p.alt}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
